/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export enum PullRequestsTableSize {
  Medium,
  Large,
}

export type ColSpans = {
  [key in PullRequestsTableSize]: {
    age?: number;
    total: number;
    activity: number;
    summary: number;
    reviewers: number;
    builds: number;
    mobileSummary: number;
    mobileBuilds: number;
  };
};

export const COL_SPANS: ColSpans = {
  [PullRequestsTableSize.Medium]: {
    total: 12,
    activity: 2,
    summary: 7,
    reviewers: 2,
    builds: 1,
    mobileSummary: 9,
    mobileBuilds: 3,
  },
  [PullRequestsTableSize.Large]: {
    total: 24,
    activity: 3,
    summary: 15,
    reviewers: 4,
    builds: 2,
    mobileSummary: 19,
    mobileBuilds: 5,
  },
};

export const COL_SPANS_WITH_AGE: ColSpans = {
  [PullRequestsTableSize.Medium]: {
    total: 14,
    activity: 2,
    summary: 7,
    reviewers: 2,
    age: 2,
    builds: 1,
    mobileSummary: 10,
    mobileBuilds: 4,
  },
  [PullRequestsTableSize.Large]: {
    total: 26,
    activity: 3,
    summary: 15,
    reviewers: 3,
    age: 3,
    builds: 2,
    mobileSummary: 21,
    mobileBuilds: 5,
  },
};

export const REVIEWER_COUNTS = {
  [PullRequestsTableSize.Medium]: 3,
  [PullRequestsTableSize.Large]: 4,
};

export const Container = styled.div({
  position: 'relative',
  minHeight: '100px',
});

export const BuildStatusTableHeader = styled.div({
  textAlign: 'center',
});

export const ActivityTableHeader = styled.div({
  textAlign: 'right',
});

export const Table = styled.table<{ isLoading?: boolean }>(props => ({
  tableLayout: 'fixed',
  pointerEvents: props.isLoading ? 'none' : 'auto',

  th: {
    color: token('color.text.subtlest'),
  },
}));
